import React from "react";

import { Alert } from "@material-ui/lab";

import { pluralize } from "lib/pluralize";

interface InProgressTransferAlertProps {
  inProgressCount: number;
  inProgressNoun: string;
  hasUnsubmittedTransfers: boolean;
}

// If we know how many rows are in progress (eg they just clicked) - tell them
// how many. Otherwise if we know things are in flight, show a generic message.
export const InProgressTransferAlert = ({
  inProgressCount,
  inProgressNoun,
  hasUnsubmittedTransfers,
}: InProgressTransferAlertProps): React.JSX.Element | null => {
  if (inProgressCount > 0) {
    return (
      <Alert severity="warning">
        We are currently transferring {inProgressCount}{" "}
        {pluralize(inProgressNoun, inProgressCount)}. Check back later.
      </Alert>
    );
  }

  if (hasUnsubmittedTransfers) {
    return (
      <Alert severity="warning">
        There are transfers pending submission. Check back later.{" "}
      </Alert>
    );
  }

  return null;
};
